import { render, staticRenderFns } from "./EditAccountant.vue?vue&type=template&id=381eb72c&scoped=true"
import script from "./EditAccountant.vue?vue&type=script&lang=js"
export * from "./EditAccountant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381eb72c",
  null
  
)

export default component.exports